const ID_TOKEN_KEY = 'plusclouds_crm_token'
const CURRENT_USER_KEY = 'plusclouds_current_user'
const CURRENT_ROUTE_KEY = 'currentRoute'
const SELECTED_DATACENTER_NODE = 'dcnode'
const SELECTED_TEAM = 'plusclouds_team'
const USER_VERIFICATION = 'user_verification'
const CUSTOM_PAGINATION_KEY = 'leo_pagination_'
const CUSTOM_PAGINATION_CACHETIME = 900 // 15 dakika = 15 * 60 saniye

export const getToken = () => {
  return window.localStorage.getItem(ID_TOKEN_KEY)
}

export const getCurrentUser = () => {
  return JSON.parse(window.localStorage.getItem(CURRENT_USER_KEY))
}

export const saveToken = (payload) => {
  window.localStorage.setItem(
    ID_TOKEN_KEY,
    `${payload.token_type} ${payload.access_token}`
  )
  window.localStorage.setItem(CURRENT_USER_KEY, JSON.stringify(payload))
}

export const destroyToken = () => {
  window.localStorage.removeItem(ID_TOKEN_KEY)
  window.localStorage.removeItem(CURRENT_USER_KEY)
}

export const getCurrentRoute = () => {
  return window.localStorage.getItem(CURRENT_ROUTE_KEY)
}
export const setCurrentRoute = (payload) => {
  window.localStorage.setItem(CURRENT_ROUTE_KEY, payload)
}
export const destroyCurrentRoute = () => {
  window.localStorage.removeItem(CURRENT_ROUTE_KEY)
}

export const getSelectedDataCenterNode = () => {
  return JSON.parse(window.localStorage.getItem(SELECTED_DATACENTER_NODE))
}
export const setSelectedDataCenterNode = (payload) => {
  window.localStorage.setItem(SELECTED_DATACENTER_NODE, JSON.stringify(payload))
}
export const destroySelectedDataCenterNode = () => {
  window.localStorage.removeItem(SELECTED_DATACENTER_NODE)
}

export const getUserTeam = () => {
  return JSON.parse(window.localStorage.getItem(SELECTED_TEAM))
}
export const setUserTeam = (payload) => {
  window.localStorage.setItem(SELECTED_TEAM, JSON.stringify(payload))
}
export const destroyUserTeam = () => {
  window.localStorage.removeItem(SELECTED_TEAM)
}

export const getUserVerification = () => {
  return JSON.parse(window.localStorage.getItem(USER_VERIFICATION))
}

export const saveUserVerification = (payload) => {
  window.localStorage.setItem(USER_VERIFICATION, JSON.stringify(payload))
}

export const destroyUserVerification = () => {
  window.localStorage.removeItem(USER_VERIFICATION)
}
export const getPaginationInfo = (name) => {
  const itemStr = window.localStorage.getItem(CUSTOM_PAGINATION_KEY + name)
  if (!itemStr) {
    return null
  }
  const item = JSON.parse(itemStr)
  let now = Math.round(Date.now() / 1000)

  if (item.expiry - now < CUSTOM_PAGINATION_CACHETIME) {
    return item.page
  }
  window.localStorage.removeItem(CUSTOM_PAGINATION_KEY + name)
  return null
}
export const setPaginationInfo = (name, page) => {
  let now = Math.round(Date.now() / 1000)
  const payload = {
    page: page,
    expiry: now + CUSTOM_PAGINATION_CACHETIME,
  }
  window.localStorage.setItem(
    CUSTOM_PAGINATION_KEY + name,
    JSON.stringify(payload)
  )
}
export const destroyPaginationInfo = (name) => {
  window.localStorage.removeItem(CUSTOM_PAGINATION_KEY + name)
}

export default {
  getToken,
  getCurrentUser,
  saveToken,
  destroyToken,
  getCurrentRoute,
  setCurrentRoute,
  destroyCurrentRoute,
  getSelectedDataCenterNode,
  setSelectedDataCenterNode,
  destroySelectedDataCenterNode,
  getUserTeam,
  setUserTeam,
  destroyUserTeam,
  getUserVerification,
  saveUserVerification,
  destroyUserVerification,
  getPaginationInfo,
  setPaginationInfo,
  destroyPaginationInfo,
}
